import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import RoomHero from '../components/RoomHero';
import RoomOverview from '../components/RoomOverview';
import RoomGallery from '../components/RoomGallery';
import OtherServices from '../components/OtherServices';
import images1 from '../assets/images/twin_1.jpg';
import images2 from '../assets/images/accomedation_2.jpg';
import images3 from '../assets/images/accomedation_4.jpg';
import images4 from '../assets/images/delux_5.jpg';
import images5 from '../assets/images/twin_5.jpg';
import images6 from '../assets/images/accomedation_5.jpg';
import images7 from '../assets/images/accomedation_7.jpg';


const RoomTwin = ({ language }) => {
  const title = { en: 'Twin Room', am: 'ትዊን ክፍል' };
  const subtitle = { en: 'Ideal for friends or colleagues', am: 'ለጓደኞች ወይም ለባልደረቦች ተስማሚ' };
  const heroImage = images1;

  const overview = {
    en: 'Our Twin Rooms feature two comfortable twin beds with essential amenities for a convenient and restful stay. A great choice for friends or colleagues traveling together.',
    am: 'ትዊን ክፍሎቻችን ለምቾት እና ለማረፍ አስፈላጊ መሳሪያዎችን ጋር ሁለት ምቹ ትዊን አልጋዎችን ያቀርባሉ። ለአብረው የሚጓዙ እንግዶች ተስማሚ ናቸው።'
  };

  const highlights = [
    { en: 'Two comfortable twin beds', am: 'ሁለት ምቹ ትዊን አልጋዎች' },
    { en: 'Smart TV and complimentary Wi‑Fi', am: 'ስማርት ቲቪ እና ነፃ ዋይ-ፋይ' },
    { en: 'Work desk and ample lighting', am: 'የስራ ጠረጴዛ እና ብርሃን' },
    { en: 'Private bathroom with amenities', am: 'በግል መታጠቢያ ቤት እና መሳሪያዎች' },
    { en: 'Accommodation includes breakfast and hotel amenities', am: 'መመዝገቢያው ቁርስን እና የሆቴሉን አመናካኝ አገልግሎቶችን ያካትታል' }
  ];

  const galleryTitle = { en: 'Twin Room Gallery', am: 'የትዊን ክፍል ጋለሪ' };
  const images = [images1, images2, images3, images4, images5, images6, images7];

  return (
    <>
      <SEO
        title="Standard Twin Room"
        description="Comfortable Twin Rooms at Blue Nest Hotel, ideal for friends or colleagues traveling together."
        url="/rooms/twin"
      />
      <RoomHero title={title} subtitle={subtitle} image={heroImage} language={language} />
      <RoomOverview language={language} overview={overview} highlights={highlights} />
      <div className="container my-4 text-center">
        <Link to="/contact" className="text-decoration-none">
          <button className="room-cta-btn">
            {language === 'am' ? 'ይዘዙ ክፍል' : 'Reserve this Room'}
          </button>
        </Link>
      </div>
      <RoomGallery language={language} title={galleryTitle} images={images} />
      <OtherServices language={language} />
    </>
  );
};

export default RoomTwin;
